import React from "react";
import styles from "./Row.module.sass";
import moment from "moment";
import Checkbox from "../../../../components/Checkbox";

const Row = ({ data, visibleColumns,isSelected, onSelect }) => {
  const formatDate = (date) => {
    const now = moment();
    const createdAt = moment(date);

    if (createdAt.isSame(now, 'day')) {
      return 'Today';
    } else if (createdAt.isSame(now.subtract(1, 'day'), 'day')) {
      return 'Yesterday';
    } else {
      return createdAt.format('DD MMM YYYY');
    }
  };
  const handleCheckboxChange = (e) => {
    onSelect(e.target.checked);
  };
  return (
    <div className={styles.row}>
      <div className={styles.col}>
        <Checkbox
          className={styles.checkbox}
          checked={isSelected}
          onChange={(e) => onSelect(e.target.checked)}
        />
      </div>  
      {visibleColumns.map((column, colIndex) => (
        <div
          key={colIndex}
          className={`whitespace-nowrap ${styles.col}`}
        >
          {column === "created_at"
            ? formatDate(data[column])
            : data[column] 
          }
        </div>
      ))}
    </div>
  );
};

export default Row;
